import { Search, Download } from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Switch } from "../ui/switch";
import { Label } from "../ui/label";

/**
 * Shared toolbar for the three admin list tabs (Users / Donors /
 * Promoters). Renders a row of three controls:
 *
 *   • Search input (debounced upstream — we just hand back onChange)
 *   • Tab-specific filter slot (`children`)
 *   • "Hide demo users" toggle
 *   • CSV export button
 *
 * The component is intentionally stateless — the parent owns
 * `q`, `includeDummy`, and the CSV handler. That keeps each tab in
 * control of its own filter logic and export columns.
 */
export default function AdminTableToolbar({
  q,
  onSearch,
  searchPlaceholder = "חיפוש לפי אימייל או שם…",
  includeDummy,
  onToggleDummy,
  onExportCSV,
  exportDisabled,
  children,
  testIdPrefix = "admin",
}) {
  return (
    <div
      className="flex flex-col md:flex-row gap-3 items-stretch md:items-center flex-wrap mb-4"
      data-testid={`${testIdPrefix}-toolbar`}
    >
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          value={q || ""}
          onChange={(e) => onSearch?.(e.target.value)}
          placeholder={searchPlaceholder}
          className="pr-9"
          data-testid={`${testIdPrefix}-search`}
        />
      </div>

      {children /* slot for filter selects */}

      <div className="flex items-center gap-2 px-3 py-1.5 rounded-sm border border-border/60 bg-card/40">
        <Switch
          checked={!includeDummy}
          onCheckedChange={(checked) => onToggleDummy?.(!checked)}
          id={`${testIdPrefix}-dummy-toggle`}
          data-testid={`${testIdPrefix}-dummy-toggle`}
        />
        <Label
          htmlFor={`${testIdPrefix}-dummy-toggle`}
          className="text-xs cursor-pointer whitespace-nowrap"
        >
          הסתר משתמשי דמו
        </Label>
      </div>

      <Button
        variant="outline"
        size="sm"
        onClick={onExportCSV}
        disabled={exportDisabled}
        data-testid={`${testIdPrefix}-export-csv`}
        className="gap-2"
      >
        <Download className="h-4 w-4" strokeWidth={1.5} />
        ייצוא ל-CSV
      </Button>
    </div>
  );
}
